<template>
    <div class="scc-small-cta-box" :class="classes">
        <p class="scc-small-cta-box__title h4">{{ title }}</p>
        <div class="scc-small-cta-box__text">
            <p v-if="content1">{{ content1 }}</p>
            <p v-if="content2">{{ content2 }}</p>
            <p v-if="content3">{{ content3 }}</p>
        </div>
        <SccLink
            v-if="buttonText && buttonLinkTo"
            class="scc-small-cta-box__button"
            button
            large
            align="start"
            :color="backgroundColor"
            inverted
            :to="buttonLinkTo"
        >
            {{ buttonText }}
        </SccLink>
    </div>
</template>

<script>
import './small-cta-box.scss';
import SccLink from './SccLink';

export default {
    name: 'SmallCtaBox',
    components: { SccLink },
    __editor: {
        fields: {
            backgroundColor: {
                widget: 'select',
                values: ['primary', 'secondary', 'body', 'white'],
            },
            border: {
                widget: 'select',
                values: ['none', 'left', 'bottom'],
            },
            margin: {
                widget: 'select',
                values: ['none', 'small', 'medium', 'large'],
            },
        },
    },
    props: {
        backgroundColor: {
            type: String,
            required: false,
            default: 'primary',
            validator: function(val) {
                return ['primary', 'secondary', 'body', 'white'].includes(val);
            },
        },
        border: {
            type: String,
            default: 'none',
            validator: function(val) {
                return ['none', 'left', 'bottom'].includes(val);
            },
        },
        title: {
            type: String,
            default: 'Doe mee en maak kans',
        },
        content1: {
            type: String,
        },
        content2: {
            type: String,
        },
        content3: {
            type: String,
        },
        buttonText: {
            type: String,
            default: 'Speel mee',
        },
        buttonLinkTo: {
            type: String,
            default: 'aanmelden',
        },
        margin: {
            type: String,
            default: 'none',
        },
    },
    computed: {
        classes() {
            return [
                `scc-small-cta-box--${this.backgroundColor}`,
                `scc-small-cta-box--border-${this.border}`,
                `scc-small-cta-box--margin-${this.margin}`,
            ];
        },
    },
};
</script>
